<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Zawodnicy</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj zawodnika</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
    <v-card class="mt-2" v-if="showAdd">
      <runner-add-form @success="showAdd = false; refresh()"></runner-add-form>
    </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-text-field v-model="context.searchQuery"
                  clearable
                  label="Szukaj"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-select
                  v-model="context.trainer"
                  :items="allTrainersOptions"
                  label="Trener"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-select
                  v-model="context.package"
                  :items="allPackagesOptions"
                  label="Pakiet"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-select
                  v-model="context.isActive"
                  :items="[{text: 'Tak', value: true}, {text: 'Nie', value: false}]"
                  label="Konto aktywne"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 lg3 class="pa-1">
                <v-checkbox
                  label="Bez treningu w tym miesiącu"
                  v-model="context.monthWithoutTraining">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 lg3 class="pa-1">
                <v-checkbox
                  label="Bez treningu w następnym miesiącu"
                  v-model="context.nextMonthWithoutTraining">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="runners"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            <router-link :to="{ name: 'runner-plan', params: { id: props.item.id }}">
              {{props.item.first_name}} {{props.item.last_name}}
            </router-link>
          </td>
          <td>{{ props.item.email}}</td>
          <td>{{ props.item.package_name}}</td>
          <td>
            {{props.item.trainer_data ? props.item.trainer_data.name : ''}}
          </td>
          <td>{{ formatterBool(props.item.account_paid)}}</td>
          <td>{{ props.item.last_training | formatDate('LL') || 'Brak'}}</td>
          <td>{{ formatterBool(props.item.is_active)}}</td>
          <td>{{ formatterBool(props.item.newsletter)}}</td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="props.expanded = !props.expanded"
            />
            <v-menu bottom left>
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="grey darken-2">more_vert</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile :to="{ name: 'runner-data', params: { id: props.item.id }}">
                  <v-list-tile-title>Szczegóły</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="props.item.is_active" @click.stop="deactivateRunner(props.item)">
                  <v-list-tile-title>Deaktywuj konto</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="!props.item.is_active" @click.stop="activateRunner(props.item)">
                  <v-list-tile-title>Aktywuj konto</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <runner-update-form :runner-data="props.item" @success="props.expanded = false; refresh()"></runner-update-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {fetchRunners, deactivateRunner, activateRunner, sendMailRunner} from './api'
import {ListMixin} from '@/utils/ListMixin'
import {boolFormatter} from '@/utils/formatters'
import iziToast from 'izitoast'
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import RunnerAddForm from './RunnerAddForm'
import RunnerUpdateForm from './RunnerUpdateForm'

export default {
  name: 'runners',
  components: {RunnerAddForm, RunnerUpdateForm},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      runners: [],
      headers: [
        {
          value: 'last_name',
          text: 'imię i nazwisko',
          sortable: true
        },
        {
          value: 'email',
          text: 'e-mail',
          sortable: true
        },
        {
          value: 'package',
          text: 'pakiet',
          sortable: true
        },
        {
          value: 'trainer',
          text: 'trener',
          sortable: true
        },
        {
          value: 'paid',
          text: 'płatności',
          sortable: false
        },
        {
          value: 'last_training',
          text: 'ostatni wpisany trening',
          sortable: true
        },
        {
          value: 'is_active',
          text: 'aktywny',
          sortable: true
        },
        {
          value: 'newsletter',
          text: 'newsletter',
          sortable: true
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          width: '180px'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions', 'allTrainersOptions'])
  },
  created () {
    this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
    this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  watch: {
    context: {
      handler () {
        this.getRunners()
      },
      deep: true
    }
  },
  methods: {
    formatterBool (data) {
      return boolFormatter(data)
    },
    getRunners (ctx) {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.package !== null) {
        params['package'] = this.context.package
      }
      if (this.context.trainer !== null) {
        params['trainer'] = this.context.trainer
      }
      if (this.context.isActive !== null) {
        params['is_active'] = this.context.isActive
      }
      if (this.context.monthWithoutTraining === true) {
        params['month_without_training'] = this.context.monthWithoutTraining
      }
      if (this.context.nextMonthWithoutTraining === true) {
        params['next_month_without_training'] = this.context.nextMonthWithoutTraining
      }
      let promise = fetchRunners(params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.runners = data
        return data
      })
    },
    sendMailRunner (item) {
      let promise = sendMailRunner(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Mail aktywacyjny został wysłany.',
          color: 'green'
        })
      })
    },
    activateRunner (item) {
      let promise = activateRunner(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Konto zostało aktywowane',
          color: 'green'
        })
      })
    },
    deactivateRunner (item) {
      let promise = deactivateRunner(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Konto zostało deaktywowane',
          color: 'green'
        })
      })
    },
    refresh: _.debounce(function () {
      this.getRunners()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/AdminRunners.vue